import { Button as ButtonAntD } from 'antd';
import styles from './button.module.scss';

export const Button = ({
    className,
    children,
    type,
    disabled,
    htmlType,
    block,
    loading,
    danger,
    icon,
    onClick,
    style
}) => {
    return (
        <ButtonAntD
            className={className ? styles[className] + ' ' + styles[`defaultButton`] : styles[`defaultButton`]}
            style={style}
            type={type}
            disabled={disabled}
            htmlType={htmlType}
            loading={loading}
            children={children}
            block={block}
            danger={danger}
            icon={icon}
            onClick={onClick}
        />
    );
}